import Payees from './Payees';

export default Payees;
